import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import { RankingsPage } from '../pages/RankingsPage';
import { ProtectedRoute } from './ProtectedRoute';
import { AdminRoute } from './AdminRoute';
import QuinielaList from '../components/quinielas/QuinielaList';
import ManageMatches from '../components/admin/ManageMatches';
import ManageResults from '../components/admin/ManageResults';
import AdminLayout from '../components/admin/AdminLayout';
import Rankings from '../components/Rankings';
import CapturedResults from '../components/quinielas/CapturedResults';
import ViewQuinielas from '../components/admin/ViewQuinielas';
import { useAuth } from '../context/AuthContext';
import ActivarQuinielas from '../components/admin/ActivarQuinielas';
import ManageUsers from '../components/admin/ManageUsers';
import ManagePredictions from '../components/admin/ManagePredictions';
import ProfilePage from '../pages/ProfilePage';

const AppRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/rankings" element={<Rankings />} />

      {/* Rutas protegidas */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/quinielas" element={<QuinielaList />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      {/* Rutas de administrador */}
      <Route element={<AdminRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="matches" element={<ManageMatches />} />
          <Route path="results" element={<ManageResults />} />
          <Route path="activar-quinielas" element={<ActivarQuinielas />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="predictions" element={<ManagePredictions />} />
        </Route>
      </Route>

      {/* Agregar nueva ruta */}
      <Route path="/quiniela/quinielas-capturadas" element={<CapturedResults />} />

      {/* Ruta por defecto */}
      <Route path="*" element={<Navigate to="/" replace />} />

      <Route
        path="/admin/ver-quinielas"
        element={
          user && user.email === 'htorres@teiker.mx'
            ? <ViewQuinielas />
            : <Navigate to="/" />
        }
      />
    </Routes>
  );
};

export default AppRoutes; 